import { AuthorizationModuleClientFactory } from '../types';

export const clientFactory: AuthorizationModuleClientFactory = (
  authorizationModuleCoreClient,
  authorizationModuleCustomClient
) => {
  return {
    ...authorizationModuleCoreClient,
    ...authorizationModuleCustomClient
  };
};
